import { render } from "./MedicarePartC.vue?vue&type=template&id=366082a8&scoped=true"
import script from "./MedicarePartC.vue?vue&type=script&lang=js"
export * from "./MedicarePartC.vue?vue&type=script&lang=js"

import "./MedicarePartC.vue?vue&type=style&index=0&id=366082a8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366082a8"]])

export default __exports__